<template>
  <div class="divide-y text-center">
    <div class="flex cursor-pointer my-3" @click="back">
      <img src="@/assets/icons/backArrow.svg" />
      <div class="self-center text-lg font-semibold grow text-black">Cash Payment</div>
    </div>
    <div>
      <WidgetMerchantLogo />
      <h1 class="text-lg m-4 text-black">Pending {{ isOrderPlaced ? 'Payment' : 'Deposit' }}</h1>
      <p class="text-sm text-black">
        {{
          isOrderPlaced
            ? 'Your payment is pending and will be paid once you make the Payment at your nearest Pay@ money counter.'
            : 'Your order is pending and will be placed once you make your first payment at your nearest Pay@ money counter.'
        }}
      </p>

      <p class="text-lg m-2 text-brand-700 text-black">Pay@ Reference: {{ payAtReference }}</p>

      <p class="text-sm mb-2 text-black">
        We will be sending you an email and sms to ensure you have the correct details to make the
        {{ isOrderPlaced ? 'payment' : 'deposit' }}.
      </p>
      <p class="text-sm mb-2 text-black">
        Please Note: If your payment is received after the due date,
        {{ isOrderPlaced ? 'your payment will be unsuccessful' : 'your order will not be placed' }}.
      </p>
    </div>

    <div class="flex flex-row text-left py-3 border-bottom mb-3">
      <p class="flex-1 text-sm text-black">Due Today {{ isOrderPlaced ? '(Payment)' : '(Deposit)' }}</p>
      <p class="font-semibold text-sm text-black">{{ amount }}</p>
    </div>

    <div v-if="errorMessage" class="rounded-md w-full bg-red-100 px-4 py-3 text-sm text-red-700">
      {{ errorMessage }}
    </div>
    <LayupButton :label="'Okay'" :isLoading="isLoading" @click="handleOkay" />
  </div>
</template>

<script setup lang="ts">
import LayupButton from '@/components/common/LayupButton.vue';
import WidgetMerchantLogo from '@/components/common/WidgetMerchantLogo.vue';
import { paymentPlanNotification } from '@/services/paymentPlans';
import { useGeneralStore } from '@/stores/general';
import { useWidgetStore } from '@/stores/widget';
import { addMetric, createException } from '@/utils/monitoring.utils';
import { getOrderLink } from '@/utils/order.utils';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { currency } from '../../../utils/format.utils';

const router = useRouter();
const isLoading = ref(false);
const errorMessage = ref('');

const widgetStore = useWidgetStore();
const generalStore = useGeneralStore();

const amount = ref(currency(widgetStore.amountDue));
const payAtReference = ref(widgetStore.payAtReference);
const isOrderPlaced = ref(widgetStore.order.state !== 'PARTIAL');

const init = async () => {
  try {
    if (!widgetStore.order.paymentMethods.payAt) {
      router.replace({ name: 'SelectPaymentMethod' });
    }
  } catch (error: any) {
    createException(error);
    errorMessage.value = 'Could not fetch order details. Please refresh to try again.';
  }
  isLoading.value = false;
};

const handleOkay = async () => {
  isLoading.value = true;
  try {
    await paymentPlanNotification(widgetStore.id);
    addMetric('accept_payment', { status: 'success', payment_method: 'pay-at', channel: 'widget' });
    const orderId = widgetStore.order._id;
    if (generalStore.iFrame) {
      window.location.href = getOrderLink(orderId!, widgetStore.order?.type).href;

      return;
    }

    window.location.href = getOrderLink(orderId!, widgetStore.order?.type).href;
  } catch (e: any) {
    createException(e);
    addMetric('accept_payment', { status: 'failure', payment_method: 'pay-at', channel: 'widget' });
    let error = 'Your notification could not be sent, please note the reference manually or try again later.';
    isLoading.value = false;
    if (e?.response?.data) {
      error = e.response.data;
    }
    errorMessage.value = error;
  }
};

const back = () => {
  router.back();
};

init();
</script>
